export enum CMSINFO_REDIRECT_QUERY {
  PLAYER_CARD = 'p',
  BETS_BY_EVENT = 'b',
  BETS_BY_PLAYER = 'bp',
  BETS_OVERVIEW = 'be',
  BETS_BY_BOOSTED_ODD_ID = 'bbo',
  EVENT_LIST = 'e',
  SUMS_REPORT = 'sr',
}
